import React from "react";
import { BRAND } from "@/lib/appApi";
import { Wrench } from "lucide-react";

export default function MaintenanceNotice({ fullscreen = true }) {
  return (
    <div data-testid="maintenance-notice" className={`${fullscreen ? "fixed inset-0 z-[80]" : "w-full"} bg-background flex flex-col items-center justify-center text-center px-8 py-16 gap-4`}>
      <img src={BRAND.logo} alt="logo" className="w-16 h-16 rounded-full" />
      <div className="w-14 h-14 rounded-2xl brand-gradient-bg flex items-center justify-center">
        <Wrench className="w-7 h-7 text-white" />
      </div>
      <h1 className="font-heading text-3xl font-extrabold">We'll be right back</h1>
      <p className="text-muted-foreground max-w-md">Random Cam Chat is temporarily down for maintenance. Please check back again shortly — thanks for your patience!</p>
    </div>
  );
}
